// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__21le-","question":"Question_question__1WVhD","description":"Question_description__1YNEh"};